import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// import resources from "./translations/resources";
import Backend from "i18next-http-backend";

import { SUPPORTED, langFromUrl, resolveLang } from "./utils/lang";
import { isPrerender } from "./utils/prerender";

export const defaultNS = "common";

// Re-exported for the route table and SEO/language components.
export { SUPPORTED };

// Initial render language. During react-snap prerender we follow the URL only
// (no cookie/navigator) so each prerendered page is deterministic. At runtime
// we apply the full priority chain — URL prefix > cookie > browser > English —
// so a French visitor landing on the root sees French content immediately,
// before <LangManager> rewrites the URL to /fr.
const detectInitialLang = (): string => {
    try {
        if (isPrerender()) return langFromUrl(window.location.pathname) || "en";
        return resolveLang(window.location.pathname);
    } catch {
        return "en";
    }
};

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        lng: detectInitialLang(),
        fallbackLng: "en",
        supportedLngs: [
            "en",
            "fr",
            "es",
            "pt",
            "de",
            "nl",
            "it",
            "pl",
            "ro",
            "el",
            "uk",
            "ja",
            "ko",
        ],
        nonExplicitSupportedLngs: true,
        load: "languageOnly",
        ns: ["common"],
        defaultNS,
        interpolation: {
            escapeValue: false,
        },
        // resources,
    });
